"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("@lingui/react");
var _core = require("@lingui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireWildcard(require("react"));
var _TextArea = _interopRequireDefault(require("./TextArea"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/button-has-type */

var HelpfulFeedback = function HelpfulFeedback(props) {
  var logToAdp = props.logToAdp;
  var _useState = (0, _react2.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    userComment = _useState2[0],
    setUserComment = _useState2[1];
  var handleChange = function handleChange(event) {
    var value = event.target.value;
    setUserComment(value);
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var payload = {
      ev: 'true',
      uc: userComment
    };
    logToAdp('helpful_comment', payload);
  };
  return /*#__PURE__*/_react2.default.createElement("div", {
    className: "dhig-pb-7 dhig-theme--light",
    "data-testid": "helpful-feedback"
  }, /*#__PURE__*/_react2.default.createElement("form", {
    className: "helpful-feedback",
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react2.default.createElement("div", {
    className: "dhig-mb-4"
  }, /*#__PURE__*/_react2.default.createElement(_TextArea.default, {
    label: /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "Do you have additional feedback about this information?"
    }),
    placeholder: _core.i18n._( /*i18n*/_core.i18n._("NOTE: Your comments here can only be seen by our editor")),
    onChange: handleChange,
    value: userComment
  })), /*#__PURE__*/_react2.default.createElement("button", {
    className: "MuiButtonBase-root MuiButton-root MuiButton-contained",
    disabled: userComment === ''
  }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "Submit feedback"
  }))));
};
HelpfulFeedback.propTypes = {
  logToAdp: _propTypes.default.func
};
HelpfulFeedback.defaultProps = {
  logToAdp: {}
};
var _default = HelpfulFeedback;
exports.default = _default;